// composables/useToast.ts
import { ref } from 'vue';

interface Toast {
  message: string;
  type: 'success' | 'error' | 'warning';
  duration: number;
}

// We use a single toasts array to store all toasts
const toasts = ref<Toast[]>([]);

export function useToast() {
  const addToast = (message: string, type: 'success' | 'error' | 'warning' = 'success', duration: number = 5000) => {
    const toast = { message, type, duration };
    toasts.value.push(toast);
    
    if (duration > 0) {
      setTimeout(() => {
        const index = toasts.value.indexOf(toast);
        if (index !== -1) {
          toasts.value.splice(index, 1);
        }
      }, duration);
    }
  };

  return {
    toasts,
    addToast,
    success: (message: string, duration: number = 7000) => addToast(message, 'success', duration),
    error: (message: string, duration: number = 7000) => addToast(message, 'error', duration),
    warning: (message: string, duration: number = 7000) => addToast(message, 'warning', duration),
    removeToast: (index: number) => {
      toasts.value.splice(index, 1);
    }
  };
}